import '@sass/cw-video.scss';
import '@sass/video-styles.scss';

function check_for_lightbox_links(a) {
  document.querySelectorAll(".cw_video_open_popup, .cw_video_open_popup_customized").forEach((element) => {
		const b = element;
		let c, d, e, f, g, h, i;
		if (a) {
		  c = a;
		} else {
		  c = b.getAttribute("video_type");
		}
		
		d = b.getAttribute("video_id");
		e = b.getAttribute("video_height") || 400;
		f = b.getAttribute("video_width") || 600;
		video_showinfo = b.getAttribute("video_showinfo");
		video_rel = b.getAttribute("video_rel");
		video_autoplay = b.getAttribute("video_autoplay") || 1;
		g = false;
		h = window.innerWidth;
		
		if (h <= 700 || h <= f) {
		  i = 0.85;
		  f = i * h;
		  f = Math.round(f);
		  i = 0.565;
		  e = f * i;
		  e = Math.round(e);
		}
		
		const lgPlugins = (typeof window.lgVideo !== 'undefined') ? [window.lgVideo] : [];
		switch (c) {
		  case "youtube": {
			const href = `https://www.youtube.com/embed/${d}?rel=${video_rel}&amp;showinfo=${video_showinfo}&amp;autoplay=${video_autoplay}&mute=1`;
			element.setAttribute('data-src', href);
			lightGallery(element, {
				selector: 'this',
				plugins: lgPlugins,
				iframeMaxWidth: f,
				iframeMaxHeight: e,
			});
			break;
		  }
		  case "vimeo": {
			const vimeoBase = b.getAttribute('video_url') || `https://player.vimeo.com/video/${d}`;
			const vimeoHref = vimeoBase + (vimeoBase.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=' + video_autoplay;
			element.setAttribute('data-src', vimeoHref);
			element.setAttribute('data-iframe', 'true');
			element.setAttribute('data-iframe-title', 'vimeo-player');
			lightGallery(element, {
				selector: 'this',
				plugins: lgPlugins,
				iframe: true,
				iframeTitle: 'vimeo-player',
				iframeMaxWidth: f,
				iframeMaxHeight: e,
			});
			break;
		  }
            case "wp_media": {
            const wpMediaUrl = b.getAttribute("video_url");
            if (wpMediaUrl) {
              // Use iframe with direct video URL so the browser's native player is used
              element.setAttribute('data-src', wpMediaUrl);
              element.setAttribute('data-iframe', 'true');
              lightGallery(element, {
                selector: 'this',
                plugins: lgPlugins,
                iframe: true,
                iframeMaxWidth: f,
                iframeMaxHeight: e,
              });
            }
            break;
            }
		}
	  });
}

document.addEventListener("DOMContentLoaded", () => {
	// Check if the current device is a mobile device
	const isMobileDevice = window.innerWidth < 768; // You can adjust this threshold as needed

	const add_popup_close_button_mobile = () => {
	if (isMobileDevice) {
		// Find the LightGallery toolbar container
		const toolbarContainers = document.querySelectorAll('.lg-container .lg-toolbar');

    // Check if there are no lg-close elements already present in any of the toolbars
			let lgCloseElementsExist = false;
			toolbarContainers.forEach((toolbarContainer) => {
				let lgCloseElements = toolbarContainer.querySelectorAll('.lg-close');
				if (lgCloseElements.length > 0) {
					lgCloseElementsExist = true;
				}
			});

			if (!lgCloseElementsExist) {
				// Create a new button element
				const customButton = document.createElement('button');
				customButton.type = 'button';
				customButton.setAttribute('aria-label', 'Close gallery');
				customButton.className = 'lg-close lg-icon';

				// Insert the custom button into all toolbar containers
				toolbarContainers.forEach((toolbarContainer) => {
					toolbarContainer.appendChild(customButton.cloneNode(true));
				});
			}
			// Add a click event listener to the lgCloseElements
			let lgCloseElements = document.querySelectorAll('.lg-container .lg-close');
			lgCloseElements.forEach((lgCloseElement) => {
				lgCloseElement.addEventListener('click', () => {
					const escapeKeyEvent = new KeyboardEvent('keydown', {
						key: 'Escape',
						code: 'Escape',
						keyCode: 27,
						which: 27,
						bubbles: true,
						cancelable: true,
						view: window,
					  });
			  
					  // Dispatch the "Escape" key press event on the document
					  // trigger esc key to close the modal
					  document.dispatchEvent(escapeKeyEvent);
				});
			  });
		}
	};

	
	check_for_lightbox_links();
	add_popup_close_button_mobile();
  });

  document.addEventListener('DOMContentLoaded', function() {

    let currentCategoryId = ''; // Initialize a variable to hold the current category
    let currentSearchQuery = ''; // Initialize a variable to hold the current search query
    let selectedCategoryId = null; 

    updateYouTubeIframeURLs();
    setLayout('grid');
    addPlayButtons('.post-type-archive-cw_video .cw_video_open_popup_customized');
    equalizeHeights('.video-title');
   
    // Set "All Categories" as active initially
    var allCategoriesLi = document.querySelector('#video-categories ul li');
    if (allCategoriesLi) {
        allCategoriesLi.classList.add('nav-active');
    }

    // Separate event listener for "All Categories" link
    var allCategoriesLink = document.querySelector('#video-categories a[href="/videos/"]');
    if (allCategoriesLink) {
        allCategoriesLink.addEventListener('click', function(event) {
            event.preventDefault();

            // Remove nav-active class from all category items
            document.querySelectorAll('#video-categories li').forEach(function(li) {
                li.classList.remove('nav-active');
            });

            // Add nav-active class to the "All Categories" li
            allCategoriesLi.classList.add('nav-active');

            // Reset the category filter
            fetchVideos('', '');
        });
    }

    // Update desktop category selection based on the selected category ID
    function updateDesktopCategorySelection() {
        document.querySelectorAll('#video-categories li').forEach(function(li) {
            li.classList.remove('nav-active');
            if (li.querySelector(`a[data-category-id="${selectedCategoryId}"]`)) {
                li.classList.add('nav-active');
            }
        });
    }

    // Update mobile dropdown selection based on the desktop category selection
    function updateMobileDropdownSelection() {
        var dropdown = document.querySelector('#videoCategoryDropdown');
        if (dropdown) {
            dropdown.value = selectedCategoryId || '';
        }
    }

    // Category selection handling
    var categoryLinks = document.querySelectorAll('#video-categories a[data-category-id]');
    categoryLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

             // Remove nav-active class from all category items
             document.querySelectorAll('#video-categories li').forEach(function(li) {
                li.classList.remove('nav-active');
            });

            // Add nav-active class to the clicked item's parent <li>
            var parentLi = this.parentNode;
            if (parentLi) {
                parentLi.classList.add('nav-active');
            }

            var categoryId = this.getAttribute('data-category-id');
            selectedCategoryId = this.getAttribute('data-category-id');
            fetchVideos(selectedCategoryId, '');

        });
    });

   // Event listener for mobile dropdown changes
    var dropdown = document.querySelector('#videoCategoryDropdown');
    if (dropdown) {
        dropdown.addEventListener('change', function(event) {
            selectedCategoryId = this.value;
            fetchVideos(selectedCategoryId, '');
        });
    }

    // Event listener for window resize
    window.addEventListener('resize', function() {
        if (window.matchMedia("(min-width: 1200px)").matches) {
            updateDesktopCategorySelection(); // Update desktop category selection
        } else {
            updateMobileDropdownSelection(); // Update mobile dropdown selection
        }
    });

    // Search form submission handling (only when present)
    var searchForm = document.getElementById('video-search-form');
    if (searchForm) {
        searchForm.addEventListener('submit', function(event) {
            event.preventDefault();
            var searchQuery = document.getElementById('video_search').value;
            fetchVideos('', searchQuery);
        });
    }

    // Function to handle AJAX requests for videos
    function fetchVideos(categoryId = currentCategoryId, searchQuery = currentSearchQuery, page = 1) {
        // Update the current state
        currentCategoryId = categoryId;
        currentSearchQuery = searchQuery;

        var xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function() {
            if (this.status === 200) {
                document.getElementById('video-gallery').innerHTML = this.responseText;
                equalizeHeights('.video-title');
                addPlayButtons('.video-trigger');
                setLayout('grid');
                updateYouTubeIframeURLs();
                check_for_lightbox_links();
            }
        };
        xhr.send('action=fetch_videos&category_id=' + categoryId + '&search_query=' + encodeURIComponent(searchQuery) + '&page=' + page + '&nonce=' + nonce);

    }

    document.addEventListener('click', function(event) {
        var el = event.target;

        if (el.classList.contains('category-pagination')) {
            event.preventDefault();
            var page = el.getAttribute('data-page');
            var categoryId = currentCategoryId; // Or fetch this dynamically if needed
            fetchVideos(categoryId, currentSearchQuery, page);
        }
    });

    function equalizeHeights(selector) {
    var elements = document.querySelectorAll(selector);
        var maxHeight = 0;

        // Reset existing heights
        elements.forEach(function(el) {
            el.style.height = 'auto';
        });

        // Find the maximum height
        elements.forEach(function(el) {
            maxHeight = Math.max(maxHeight, el.getBoundingClientRect().height);
        });

        // Apply maximum height to all elements
        elements.forEach(function(el) {
            el.style.height = maxHeight + 'px';
        });
    }

    // Debounce function to prevent excessive calculations
    function debounce(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, wait);
        };
    }

    // Apply the equalizeHeights function on window resize with debounce
    window.addEventListener('resize', debounce(function() {
        equalizeHeights('.video-title');
    }, 250));


    function addPlayButtons(selector) {
       // console.log('Play Button Fnc');
       let playButtonSrc = (typeof playVideoUrl !== 'undefined' && playVideoUrl) ? playVideoUrl : (typeof cwVideoGlobals !== 'undefined' && cwVideoGlobals.playVideoUrl) ? cwVideoGlobals.playVideoUrl : '';
       if (!playButtonSrc) return;

            // Get all video link elements using the passed selector
            let videoLinks = document.querySelectorAll(selector);
           // console.log('Found elements:', videoLinks.length);

            // Iterate over each video link and add the play button image
            videoLinks.forEach(function(videoLink,index) {
                //console.log('Processing element ' + index, videoLink);
                if (!videoLink.querySelector('.video-play')) {
                    let playButtonImg = document.createElement('img');
                    playButtonImg.src = playButtonSrc;
                    playButtonImg.classList.add('video-play');
                    playButtonImg.alt = 'Play Video';
                    videoLink.insertBefore(playButtonImg, videoLink.firstChild);
                }
            });
        }

        function updateYouTubeIframeURLs() {
            const iframes = document.querySelectorAll('.cw_video_single');

            iframes.forEach(iframe => {
                const isYouTubeVideo = iframe.src.includes('youtube.com/embed/');
                const hasMuteParam = iframe.src.includes('mute=1');

                if (isYouTubeVideo && !hasMuteParam) {
                    iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'mute=1';
                }
            });
        }
    });

    // Handles the layout switching logic (only on video archive page)
    function setLayout(layout) {
        const videoGallery = document.getElementById('video-gallery');
        const listLayoutBtn = document.getElementById('list-layout');
        const gridLayoutBtn = document.getElementById('grid-layout');
        if (!videoGallery || !listLayoutBtn || !gridLayoutBtn) return;

        const videoItems = document.querySelectorAll('.video-item-wrap');

        // Remove all grid/list classes
        videoItems.forEach(function(item) {
            item.classList.remove('col-md-6', 'col-lg-4', 'col-md-12', 'col-lg-12');
        });

        // Apply the appropriate classes for list or grid layout
        if (layout === 'list') {
            videoItems.forEach(function(item) {
                item.classList.add('col-md-12', 'col-lg-12');
            });
            videoGallery.classList.add('list-view');
            videoGallery.classList.remove('grid-view');
            listLayoutBtn.classList.add('active');
            gridLayoutBtn.classList.remove('active');
        } else { // Default to grid layout
            videoItems.forEach(function(item) {
                item.classList.add('col-md-6', 'col-lg-4');
            });
            videoGallery.classList.add('grid-view');
            videoGallery.classList.remove('list-view');
            gridLayoutBtn.classList.add('active');
            listLayoutBtn.classList.remove('active');
        }
    }

    // Event listeners for layout buttons (only when present)
    const listLayoutEl = document.getElementById('list-layout');
    const gridLayoutEl = document.getElementById('grid-layout');
    if (listLayoutEl) listLayoutEl.addEventListener('click', function() { setLayout('list'); });
    if (gridLayoutEl) gridLayoutEl.addEventListener('click', function() { setLayout('grid'); });

  